import { Component, inject, OnInit, input, computed } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { rxResource } from '@angular/core/rxjs-interop';

// Third-party
import { NgxPermissionsService } from 'ngx-permissions';

// Fontawesome
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCircleInfo, faSearch } from '@fortawesome/free-solid-svg-icons';

// NG-Bootstrap
import { NgbModal, NgbNavModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

// Components
import { NavbarComponent } from "../../../template/components/navbar/navbar.component";
import { DocumentListComponent } from "../../../documents/components/document-list/document-list.component";
import { UrlPatternListComponent } from "../../../url-patterns/components/url-pattern-list/url-pattern-list.component";
import { ContextSetupComponent } from "../context-setup/context-setup.component";
import { ConfirmModal } from '../../../shared/components/confirm-modal/confirm-modal.component';

// Pipes
import { ByteConverterPipe } from '../../../shared/pipes/byte-converter.pipe';

// Services
import { ContextService } from '../../services/context.service';


@Component({
  selector: 'app-context-management',
  imports: [NgbNavModule, NavbarComponent, DocumentListComponent, FormsModule, FontAwesomeModule, UrlPatternListComponent, ByteConverterPipe, ContextSetupComponent, NgbTooltipModule, DatePipe],
  templateUrl: './context-management.component.html',
  styleUrl: './context-management.component.scss'
})
export class ContextManagementComponent implements OnInit {
  private readonly permissionsSrv = inject(NgxPermissionsService);
  private readonly contextSrv = inject(ContextService);
  private readonly modalSrv = inject(NgbModal);

  activeMain = 'configurazione';
  activeSub1 = 'documenti';

  faSearch = faSearch;
  faCircleInfo = faCircleInfo;

  contextSetupFormDirty = false;

  readonly id = input.required<string>();

  readonly contextResource = rxResource({
    params: this.id, // in Angular 19 si chiama `request`
    stream: ({ params: contextId }) => this.contextSrv.getContextDetail(contextId),
  });

  navList = computed(() => [
    { label: 'Lista Contesti', routePath: '/contexts', loading: false },
    {
      label: this.contextResource.value()?.name ?? '',
      routePath: `/contexts/${this.id()}/management`,
      loading: this.contextResource.isLoading(),
    },
  ]);

  searchPlaceholder: string = $localize`Cerca nome documento...`;
  searchTerm: string = '';

  urlDocNumber: number = -1;

  hasAdmPermission: boolean = false;

  ngOnInit(): void {
    this.permissionsSrv.hasPermission('ROLE_ADM').then((hasPermission) => {
      this.hasAdmPermission = hasPermission;
      if (hasPermission) {
        this.activeMain = 'contenuti';
      }
    });
  }

  updatePlaceholder(activeTab: string) {
    this.searchTerm = '';
    this.searchPlaceholder = activeTab === 'documenti' ? $localize`Cerca nome documento...` : $localize`Cerca Siti Web...`;
  }

  onStateChanged(dirty: boolean) {
    this.contextSetupFormDirty = dirty;
  }

  canDeactivate() {
    if (this.contextSetupFormDirty) {
      const modalRef = this.modalSrv.open(ConfirmModal, { centered: true, windowClass: 'qai-modal' });
      modalRef.componentInstance.title = $localize`Modifiche non salvate`;
      modalRef.componentInstance.body = $localize`Ci sono delle modifiche non salvate nella configurazione del contesto. Se abbandi questa pagina, le modifiche non saranno applicate e andranno perse.`;

      return modalRef.result
        .then(() => true)      // Utente conferma uscita
        .catch(() => {
          // Scroll fino al fondo della pagina per garantire la visibilità dei pulsanti del modal
          try {
            // Scroll “dolce” verso il fondo del documento
            window.scrollTo({
              top: document.body.scrollHeight,
              behavior: 'smooth'
            });
          } catch (_) {
            // fallback in caso di incompatibilità
            window.scrollTo(0, document.body.scrollHeight);
          }

          return false; // Utente annulla (chiude modale)
        });
    }

    return true; // Nessuna modifica non salvata, può uscire tranquillamente
  }

}